export default __webpack_public_path__ + "static/media/homesl2.5cadc2b4.png";